import { useMemo } from 'react';
import { useAccessToken } from '../auth/use-access-token.js';
import { apiFetch } from './client.js';
import { practiceOutbox } from './practice-outbox.js';
import { practiceOutboxStore } from './practice-outbox-store.js';

/** The phone's outbox, sending through PUT and PATCH /api/practices/{id}. */
export function usePracticeOutbox() {
  const getToken = useAccessToken();
  return useMemo(
    () =>
      practiceOutbox(practiceOutboxStore, {
        save: (practice) =>
          apiFetch(`/api/practices/${encodeURIComponent(practice.id)}`, getToken, {
            method: 'PUT',
            body: JSON.stringify({
              athlete_client_id: practice.athleteClientId,
              practice_date: practice.practiceDate,
              first_swing_at: practice.firstSwingAt,
              last_swing_at: practice.lastSwingAt,
              swing_count: practice.swingCount,
            }),
          }),
        update: (id, edited) =>
          apiFetch(`/api/practices/${encodeURIComponent(id)}`, getToken, {
            method: 'PATCH',
            body: JSON.stringify(edited),
          }),
      }),
    [getToken],
  );
}
